import * as React from "react";
import noimage from "../../../../images/noasset.jpeg";
import { Checkbox, Typography } from "@mui/material";
import FileDropZone from "../../../common/FileDropZone";
import Can from "../../../common/Can";
import { usePermissionContext } from "../../../../contexts/ProviderProvider";

export const TeamImageModifier = ({
    label,
    style,
    original,
    value,
    shared,
    toggleShared,
    setValue,
    permissions,
}) => {

    const [previewURL, setPreviewURL] = React.useState(null);
    const [error, setError] = React.useState(null)
    const { actions } = usePermissionContext();

    React.useEffect(() => {
        console.log("value in useEffect: ", value)
        if (value && (value instanceof Blob || value instanceof File)) {

            if (["image/png"].includes(value.type)) {

                const url = URL.createObjectURL(value);
                setPreviewURL(url)
                setError(null)
                // cleanup on unmount or when value chages
                return () => {
                    URL.revokeObjectURL(url);
                }
            } else {
                setPreviewURL(null)
                setError("Only PNG files are allowed")
            }
        } else {
            setPreviewURL(null)
        }
    }, [value])

    React.useEffect(() => {
        console.log("previewURL: ", previewURL)
    }, [previewURL])

    const handleImageChange = (files, callback) => {
        if (files && files[0] && (files[0] instanceof File || files[0] instanceof Blob)) {
            const file = files[0]

            if (["image/png"].includes(file.type)) {
                setValue(file);
                setError(null); // Clear error on valid file
                callback();
            } else {
                setError("Please select a PNG file.");
            }
        } else {
            setError("No valid file provided.");
        }
    };


    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
            }}
        >
            {error && <Typography color="error">{error}</Typography>}
            {previewURL || original ? (
                <img
                    alt={"photo of " + label}
                    style={{ maxHeight: "100px" }}
                    src={previewURL || original || noimage}
                    onClick={() => {
                        const url = previewURL || original || noimage
                        window.open(url, "_blank")
                    }}
                />
            ) : (
                <div>no image | only accept PNG</div>
            )}
            <Can
                action={actions.ALTER}
                items={permissions}
            >
                <FileDropZone
                    single
                    sx={{
                        width: "70%",
                    }}
                    text={"Drag and drop " + label}
                    uploadFiles={(files, callback) => {
                        handleImageChange(files, callback);
                    }}
                />
                {toggleShared && (
                    <>
                        <Checkbox
                            checked={shared}
                            onClick={() => {
                                toggleShared(!shared);
                            }}
                        />
                        <Typography>Is Shared</Typography>
                    </>
                )}
            </Can>
        </div>
    );
};
